module.exports = __webpack_public_path__ + "img/tasks.ef9e9285.webp";